import type { FormControlSetting, Setting } from '@/app/editor/iframe/atom/Atom.model';
import { GpElement } from '@/app/editor/iframe/atom/element/GpElement';
import iconInfo from '@/app/editor/sidebar/elementsInfo/icon';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'html:replace',
    name: 'choose-icon',
    targetSelector: '.gf_icon-wrap',
    replaceData: {
      replaceTarget: '.gf_icon',
      replaceType: 'icon',
    },
    property: '',
  },
  {
    type: 'css',
    name: 'icon-color',
    fieldType: 'color',
    targetSelector: '.gf_icon-wrap',
    property: 'color',
  },
  {
    type: 'css',
    name: 'icon-size',
    targetSelector: '.gf_icon-wrap',
    require: true,
    property: 'font-size',
  },
  {
    type: 'custom:align',
    name: 'icon-align',
    targetSelector: '.elm',
    require: true,
    property: 'text-align',
  },
  {
    type: 'html:autoWrapLink',
    name: 'editLink',
    targetSelector: '.gf_icon-wrap',
    property: 'href',
  },
  {
    type: 'html:attr',
    name: 'iccon-target',
    targetSelector: '.elm a',
    property: 'target',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Button Atom Element
 */
export class GpIcon extends GpElement {
  public $el: JQuery;

  /**
   * [Hook] [override]
   * @param settings ()
   * @returns settings data
   */
  formatSettingAtom(settings: Array<Setting>): Array<Setting> {
    return settings.length > 0 ? settings : iconInfo.settings;
  }

  /**
   * [Hook] [override]
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || iconInfo.name;
  }

  /**
   * [Hook] [override]
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || iconInfo.slug;
  }

  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '.' + iconInfo.class;
  }
}
